// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status--FfY9f{color:#fff;background-image:linear-gradient(90deg, #71bf49, #25abdd)}", "",{"version":3,"sources":["webpack://./src/gui/Components/Status/Won/index.module.scss"],"names":[],"mappings":"AAAA,eAAQ,UAAU,CAAC,yDAAyD","sourcesContent":[".status{color:#fff;background-image:linear-gradient(90deg, #71bf49, #25abdd)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": "status--FfY9f"
};
export default ___CSS_LOADER_EXPORT___;
